import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { SharesTitle } from 'types';

type ShareTitleTooltipTextProps = {
  sharesTitle: Partial<SharesTitle>;
};

export const ShareTitleTooltipText: FC<ShareTitleTooltipTextProps> = ({
  sharesTitle,
}) => {
  const { t } = useTranslate();

  return sharesTitle?.number ? (
    <span>
      <span className="fw-bold text-decoration-underline">
        {t('Title')} #{sharesTitle.number}
      </span>
      <br />
      <span>{t('SharesTitleOnlyPartner')}</span>
    </span>
  ) : (
    <span>{t('SharesTitleOnlyPartner')}</span>
  );
};

export const ShareTitleTooltipTextWithCoOwners: FC<
  ShareTitleTooltipTextProps
> = ({ sharesTitle }) => {
  const { t } = useTranslate();

  return sharesTitle?.number ? (
    <span className="d-block text-center ">
      <span className="fw-bold text-decoration-underline">
        {t('Title')} #{sharesTitle.number}
      </span>
      <br />
      <span>{t('SharesTitleWithCoOwners')}</span>
    </span>
  ) : (
    <span>{t('SharesTitleWithCoOwners')}</span>
  );
};
